module.exports = "<div class=\"\">\r\n  <jujo_component specialized=\"false\" comp=\"jujo_blog\"></jujo_component>\r\n</div>\r\n"